import i18n, { SupportedLanguageCode } from 'src/lib/i18n';
import { RestAPIInstance } from 'src/lib/rest-api';

// Caches bundles in-memory; never refetches a language already loaded.
export async function loadLanguage(code: SupportedLanguageCode): Promise<void> {
  if (!i18n.hasResourceBundle(code, 'translation')) {
    const response =
      await RestAPIInstance.apis.translations.translationsControllerGetTranslations(
        code,
      );
    i18n.addResourceBundle(code, 'translation', response.data, true, true);
  }
  if (i18n.language !== code) {
    await i18n.changeLanguage(code);
  }
}
